import {observer} from "mobx-react";
import {App} from "./App";
import {PmsTabType, PmsOverviewPage, PmsCreatePage, PmsDetailPage} from "../page/pms";

interface PmsAppProps {
    mode: 'overview' | 'create' | 'detail'
    tab?: PmsTabType
}

const PmsApp = observer(function PmsApp({mode, tab}: PmsAppProps) {
    return <App>
        {mode === 'overview' && <PmsOverviewPage tab={tab}/>}
        {mode === 'create' && <PmsCreatePage/>}
        {mode === 'detail'&& <PmsDetailPage/>}
    </App>
})

export {
    PmsApp
}
